import React from 'react';
import {
  List as RaList,
  useGetIdentity,
  TextField,
  DateField,
  FunctionField,
  BooleanField,
} from 'react-admin';
import { DateTime } from 'luxon';
import ReactJson from 'react-json-view';
import { Done, Error } from '@material-ui/icons';

import { usePageTitle } from '../../../components/usePageTitle';
import { withPermissions } from '../../../components/hoc/WithPermissions';
import { USER_TYPE } from '../../../constants/statuses';
import { CUSTOM_STORAGE } from '../../../constants/list-column-custom-storage';
import CustomizableDatagrid from '../../../utils/libs/CustomizableDatagridLib';
import { Filter } from './Filter';
import { ShowIdButton } from '../../../components/ShowIdButton';
import { useStyles } from '../styles';

const List = (props) => {
  usePageTitle(props);
  const classes = useStyles();
  const { loading: identityLoading } = useGetIdentity();
  const DEFAULT_COLUMNS = ['id', 'status'];

  if (identityLoading) {
    return null;
  }
  const filterDefValues = {
    'createdAt||$gte': DateTime.now().minus({ days: 30 }).toISODate(),
    'createdAt||$lt': DateTime.now().plus({ days: 1 }).toISODate(),
  };
  return (
    <RaList
      {...props}
      sort={{ field: 'id', order: 'DESC' }}
      filterDefaultValues={filterDefValues}
      filters={<Filter />}
      bulkActionButtons={false}
    >
      <CustomizableDatagrid
        storage={CUSTOM_STORAGE}
        defaultColumns={DEFAULT_COLUMNS}
      >
        <ShowIdButton source="id" />
        <TextField source="action" />
        <TextField label="User name" source="user.fullName" />
        <FunctionField
          source="isSucces"
          render={({ isSucces }) => (isSucces
            ? <BooleanField TrueIcon={Done} style={({ color: 'green' })} source="isSucces" />
            : <BooleanField source="isSucces" FalseIcon={Error} style={{ color: 'red' }} />)}
        />
        <FunctionField
          label="Request"
          render={(record) => (
            <div className={classes.container}>
              <ReactJson
                collapsed
                enableClipboard={false}
                displayObjectSize={false}
                displayDataTypes={false}
                name="Request"
                src={JSON.parse(record.request)}
              />
            </div>
          )}
        />
        <FunctionField
          label="Response"
          render={(record) => (
            <ReactJson
              collapsed
              enableClipboard={false}
              displayObjectSize={false}
              displayDataTypes={false}
              name="Response"
              src={JSON.parse(record.response)}
            />
          )}
        />
        <DateField
          showTime
          formatDate={(date) => date.toISODate()}
          sortable={false}
          source="createdAt"
        />
        <DateField showTime sortable={false} source="updatedAt" />
      </CustomizableDatagrid>
    </RaList>
  );
};
export default withPermissions(
  List,
  [USER_TYPE.MANAGER, USER_TYPE.WORKER, USER_TYPE.DEVELOPER],
  null,
);
